"use client";

import { useEffect } from "react";
import { useRouter } from "next/navigation";

export default function StorylanePopup({ storylaneId }: { storylaneId: string }) {
    const router = useRouter();

    useEffect(() => {
        const script = document.createElement("script");
        script.src = "https://js.storylane.io/js/v1/storylane.js";
        script.onload = () => {
            if (typeof (window as any).Storylane !== 'undefined') {
                (window as any).Storylane.Play({
                    type: 'popup',
                    demo_type: 'image',
                    demo_url: storylaneId === '10kdemo' ?
                        (window.innerWidth > 768 ? 'https://clearitty.storylane.io/demo/rlooc0xeb4fy?embed=popup' : 'https://clearitty.storylane.io/demo/vs5lnkmv8tlm?embed=popup') :
                        (window.innerWidth > 768 ? 'https://clearitty.storylane.io/demo/j4tzbmwq4btr?embed=popup' : 'https://clearitty.storylane.io/demo/utp2ppv6zvwd?embed=popup')
                    ,
                });
                const closeButton = document.querySelector('.__sl-close-btn');
                if (closeButton) {
                    closeButton.addEventListener('click', () => {
                        window.location.href = '/';
                    });
                } else {
                    console.error("Close button not found");
                }
                const iframeContainer = document.querySelector('.__sl-embed-container');
                if (iframeContainer) {
                    iframeContainer.classList.add('p-4');
                }
                const embedWrapper = document.querySelector('.__sl-embed-wrapper');
                if (embedWrapper) {
                    embedWrapper.classList.add('!h-full');
                }
                const embed = document.querySelector('.__sl-embed');
                if (embed) {
                    embed.classList.add('!h-full');
                }
            } else {
                console.error("Storylane is not defined");
            }
        };
        script.onerror = () => {
            console.error("Failed to load the Storylane script");
        };
        document.body.appendChild(script);
    }, [router]);

    return null;
}